// extracted by css-extract-rspack-plugin
export default {"size_s":"K5iiY","sizeS":"K5iiY","left_icon":"pCUCm","leftIcon":"pCUCm","size_m":"jMeZy","sizeM":"jMeZy","size_l":"HWRLh","sizeL":"HWRLh","size_xl":"FrntK","sizeXl":"FrntK"};